export function mobileNav() {
    const $body = $("body");
    const $header = $(".header");
    const $menuDrop = $header.find(".menu-item-has-children");
    const newsBar = $(".header-holder .small-news-bar");
    $(".mobile-menu-opener").on("click", function (e) {
        $body.toggleClass("menu-opened");
        if (newsBar.length) {
            newsBar.slideToggle(300);
        }
        e.preventDefault();
    });

    $menuDrop.each(function (i, it) {
        $(it).find(">a").after("<button class='menu-drop-opener'><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\">\n" +
            "  <path d=\"M11.5 7L8 11L4.5 7\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"square\"/>\n" +
            "</svg></button>");
    });
    $body.on("click", ".menu-drop-opener", function () {
        if (!$(this).parent("li").hasClass("open")) {
            $(this).parent("li").addClass("open");
            if ($body.hasClass("touch")) {
                $(this).parent("li").find("ul").slideDown(500);
            }
        } else {
            $(this).parent("li").removeClass("open");
            if ($body.hasClass("touch")) {
                $(this).parent("li").find("ul").slideUp(500);
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileNav.js